/**
 * Messages of the browsers and of Vite when the code of a lazily loaded screen cannot be fetched:
 * Chromium („Failed to fetch dynamically imported module“), Firefox („error loading dynamically
 * imported module“), Safari („Importing a module script failed.“) and the style sheet preload of
 * Vite („Unable to preload CSS for …“).
 */
const chunkLoadMessage =
  /dynamically imported module|importing a module script failed|unable to preload css/iu;

/**
 * Returns whether an error means that the code of a screen could not be loaded: offline before the
 * screen was cached, or a file of an older version that a deployment removed (UX-109).
 *
 * @param error - The error a route reported.
 * @returns `true` for a failed code load.
 */
export function isChunkLoadError(error: unknown): boolean {
  const failedLoad = error instanceof Error && chunkLoadMessage.test(error.message);

  return failedLoad;
}
